// Central location for all environment variables
const env = {
  // Logo URLs
  logoUrl: process.env.REACT_APP_LOGO_URL || 'https://legate-images.s3.us-west-2.amazonaws.com/cropped-Legate-Business-consulting-black-logo-1.png',
  footerLogoUrl: process.env.REACT_APP_FOOTER_LOGO_URL || 'https://legate-images.s3.us-west-2.amazonaws.com/Legate-Business-consulting-white-logo.png',
  
  // API endpoints
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:3001', // Default to local dev server if not set
  
  // AWS Configuration for blog
  aws: {
    region: process.env.REACT_APP_AWS_REGION || 'us-west-2',
    bucketName: process.env.REACT_APP_BLOG_BUCKET_NAME || 'legate-blog-content',
    blogsPrefix: 'blogs/',
    imagesPrefix: 'blogs/images/',
    indexFile: 'blogs/blog-index.json',
    // Add downloads configuration
    downloadsPrefix: 'downloads/',
    downloadsIndexFile: 'downloads/index.json',
    downloadFilesPrefix: 'downloads/files/'
  },
  
  // Blog Configuration
  blog: {
    categories: [
      "Business Formation",
      "Legal",
      "Tax Planning",
      "Branding",
      "Finance",
      "Growth"
    ],
    defaultAuthor: {
      name: "Legate Business Consulting",
      role: "Business Formation Specialists",
      bio: "Legate Business Consulting helps entrepreneurs establish their businesses on solid legal ground with accessible, personalized support throughout the formation process."
    }
  },
  
  // Authentication (for blog admin)
  auth: {
    // In a production app, you would use environment variables
    username: "admin",
    password: "your-secure-password"
  },
  
  // Other configuration values
  isProd: process.env.NODE_ENV === 'production',
  isDev: process.env.NODE_ENV === 'development',
};

export default env;
